import Definitions from "../../http_request/Model/Definitions/Definitions";
import {toast} from "react-toastify";

export const getFilterPalletStatus = (setFilterPalletStatus, setLoading) => {
    Definitions.request({
        beforeSend: () => {
            setLoading(true)
        },
        success: (data) => {
            // let res = []
            // data.map((item, index) => {
            //     res = [...res, {label: item.name, value: item.id,}]
            // })
            setFilterPalletStatus(data);
        },
        error: ({error}) => {
            toast.error(error.data.message);
        },
        final: (data) => {
            setLoading(data);
        },
    }).FilterPalletStatus();
};
